/**
 * Modales génériques
 */
$(document).on('click', '[data-modal]', function (event) {
    event.preventDefault();
    const $this = $(this);
    const target = $this.data('modal');

    if(!$this.is('.button--disabled') && !$this.is('[disabled]')) {
        $('#' + target).show();
    }
});

$(document).on('click', function (event) {
    if ($(event.target).hasClass('modal') && $(event.target).attr('id') != 'login') {
        $(event.target).hide();
    }
});

$('.modal').on('click', '.close', function (e) {
    e.preventDefault();

    $(this).parents('.modal').hide();
});

const signInModal = $('#login');

$(document).on('click', function (event) {
    if (event.target == signInModal.get(0)) {
        signInModal.hide();
    }
});

/**
 * Modale catalogue
 */
const modal = $('.popup-detailed').first();

if (modal.length) {
    var options = {};
    var loader = '<svg xmlns="http://www.w3.org/2000/svg" style="margin:auto;background:0% 0%" width="200" height="200" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" display="block"><circle cx="84" cy="50" r="10" fill="#52c0e7"><animate attributeName="r" repeatCount="indefinite" dur="0.3731343283582089s" calcMode="spline" keyTimes="0;1" values="10;0" keySplines="0 0.5 0.5 1" begin="0s"/><animate attributeName="fill" repeatCount="indefinite" dur="1.4925373134328357s" calcMode="discrete" keyTimes="0;0.25;0.5;0.75;1" values="#52c0e7;#1b3d71;#846bb2;#6cc2b5;#52c0e7" begin="0s"/></circle><circle cx="16" cy="50" r="10" fill="#52c0e7"><animate attributeName="r" repeatCount="indefinite" dur="1.4925373134328357s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s"/><animate attributeName="cx" repeatCount="indefinite" dur="1.4925373134328357s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s"/></circle><circle cx="50" cy="50" r="10" fill="#6cc2b5"><animate attributeName="r" repeatCount="indefinite" dur="1.4925373134328357s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3731343283582089s"/><animate attributeName="cx" repeatCount="indefinite" dur="1.4925373134328357s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3731343283582089s"/></circle><circle cx="84" cy="50" r="10" fill="#846bb2"><animate attributeName="r" repeatCount="indefinite" dur="1.4925373134328357s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7462686567164178s"/><animate attributeName="cx" repeatCount="indefinite" dur="1.4925373134328357s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7462686567164178s"/></circle><circle cx="16" cy="50" r="10" fill="#1b3d71"><animate attributeName="r" repeatCount="indefinite" dur="1.4925373134328357s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1194029850746268s"/><animate attributeName="cx" repeatCount="indefinite" dur="1.4925373134328357s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1194029850746268s"/></circle></svg>';

    /**
     * Affichage de la popup
     */
    $(document).on('click', '.see-more', function () {
        options = {};
        const id = $(this).data('id');

        $.ajax({
                type: 'POST',
                url: ajaxurl,
                data: {
                    action: 'displayOfferOptions',
                    offer: id,
                },
                beforeSend: function () {
                    modal.find('.modal-content').empty().html(loader);
                    modal.show();
                }
            })
            .done(function (data) {
                modal.find('.modal-content').html(data);
            })
            .fail(function (data) {
                modal.find('.modal-content').append('Error ' + data.status + ': ' + data.statusText);
            });
    });

    /**
     * Masquage de la popup lorsqu'on clique sur le fond
     */
    $(document).on('click', function (event) {
        if (event.target == modal.get(0)) {
            modal.hide();
        }
    });

    /**
     * Fermeture avec la croix
     */
    $(modal).on('click', '.close', function (e) {
        e.preventDefault();

        modal.hide();
    });

    /**
     * Click sur les boutons d'ajout d'option, sous forme de toggle
     */
    $(modal).on('click', '.add-to-cart-button', function (e) {
        const id = $(this).data('id');
        const price = $(this).data('price');
        const title = $(this).data('title');

        /**
         * On ne peut choisir qu'une option à la fois mais
         * si on clique de nouveau sur l'une d'elle, alors
         * on repasse sans options du tout.
         */
        if(options[id] == undefined) {
            options = {};
            options[id] = {
                title: title,
                price: parseFloat(price)
            };

            $(modal).find('.add-to-cart-button.clicked').removeClass('clicked');
            $(this).addClass('clicked');
        }
        else {
            options = {};
            $(this).removeClass('clicked');
        }
        
        computeTotal();
    });

    /**
     * Fait la somme des options sélectionnées
     */
    function computeTotal() {
        var total = parseFloat($('#offer-price').data('price'));
        $('.popup-recap-options').empty();

        for (var id in options) {
            if (options.hasOwnProperty(id)) {
                total += parseFloat(options[id].price);

                $('.popup-recap-options').append(
                    $('<p>').html(
                        options[id].title + ' <span class="total">' + window.money(options[id].price) + '</span>'
                    )
                );
            }
        }

        $('#grand-total').hide().html(window.money(total)).fadeIn();
    }

    /**
     * Ajout au panier
     */
    $(modal).on('click', '.button--add-to-cart-popup', function (e) {
        const $this = $(this);
        const offer = $this.data('offer');

        $.ajax({
                type: 'POST',
                url: ajaxurl,
                data: {
                    action: 'addToCart',
                    offer: offer,
                    options: Object.keys(options)
                },
                beforeSend: function () {
                    $this.attr('data-default-label', $this.text());
                    $this.text('Ajout en cours…');
                }
            })
            .done(function (result) {
                if(result.success) {
                    $this.text('Ajouté !');

                    window.refreshMiniCart(function () {
                        modal.fadeOut();
                        $('.mini-cart').addClass('mini-cart--opened');

                        setTimeout(() => {
                            $('.mini-cart').removeClass('mini-cart--opened');
                        }, 3000);
                    });

                    const $offer = $('.catalog-offer.offer-' + offer);
                    $offer.addClass('checked');
                    $offer.find('.button.see-more').attr('disabled', true);

                    if(result.data.itemsInCart != undefined) {
                        $('.itemsInCart').text(result.data.itemsInCart > 0 ? result.data.itemsInCart : '');
                    }
                }
                else {
                    const $popupAlert = $this.parents('.popup').find('.popup__alert');
                    
                    if($popupAlert && result?.data?.status) {
                        switch (result.data.status) {
                            case 'OFFER_ALREADY_IN_CART':
                                $popupAlert.text('Cette offre est déjà dans votre panier');
                            break;

                            case 'OFFER_NOT_FOUND':
                            case 'EMPTY_RECRUITEMENT':
                            case 'CART_MISSING':                                
                            default:
                                $popupAlert.text('Une erreur s\'est produite. Veuillez réessayer ultérieurement.');
                            break;
                        }
                    }

                    $this.text($this.attr('data-default-label'));
                }
            })
            .fail(function (error) {
                console.error('fail', error);
            });
    });
}